<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-p-4 ts-border ts-border-dashed ts-rounded-md">
      <h1 class="ts-text-lg ts-text-gray-600">
        {{ $t('paymentAdjustment.searchInvoice') }}
      </h1>
      <div class="ts-relative ts-flex ts-items-center">
        <input
          v-model="search"
          type="text"
          class="ts-border ts-border-gray-400 ts-rounded ts-py-1 ts-px-8 ts-outline-none ts-w-full"
          placeholder="Search| invoice #, student name, student ID"
          @input="fetchInvoice()"
        />
        <i class="fas fa-search ts-absolute ts-left-0 ts-ml-3"></i>
      </div>
      <div class="ts-h-64 ts-mt-2 ts-overflow-y-scroll">
        <table class="ts-w-full">
          <thead>
            <tr class="ts-border-b">
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.invoiceNumber') }}
              </td>
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.studentName') }}
              </td>
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.gradeName') }}
              </td>
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.className') }}
              </td>
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.totalAmount') }}
              </td>
              <td
                class="ts-uppercase ts-font-semibold ts-px-2 ts-top-0 ts-sticky ts-bg-gray-200 ts-py-1"
              >
                {{ $t('paymentAdjustment.invoiceDate') }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(i, index) in invoices"
              :key="index"
              class="ts-cursor-pointer hover:ts-shadow-lg ts-transition-all ts-duration-150"
              @dblclick="onRowInvoiceClick(i)"
            >
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                {{ i.inv_number }}
              </td>
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                {{ i.first_name_en + ' ' + i.last_name_en }}
              </td>
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                {{ i.grade_name_foreign }}
              </td>
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                {{ i.class_name }}
              </td>
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                <div class="ts-flex ts-justify-between">
                  <p>$</p>
                  <p>{{ i.total_amount }}</p>
                </div>
              </td>
              <td class="ts-px-2 ts-py-1 ts-border-dashed ts-border-b">
                {{ i.inv_date }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'
export default {
  name: 'searchInvoice',
  data() {
    return {
      loading: false,
      search: '',
      invoices: []
    }
  },
  computed: {
    ...mapState('paymentAdjustment', ['edit_data'])
  },
  created() {
    if (isEmpty(this.edit_data)) {
      this.fetchInvoice()
    }
  },
  methods: {
    ...mapActions('paymentAdjustment', ['formViewModel']),
    fetchInvoice: debounce(function(search = undefined) {
      this.loading = true
      return this.formViewModel({
        invoiceSearch: search != undefined ? search : this.search,
        fnName: 'invoice'
      })
        .then(response => {
          this.invoices = response.invoice
        })
        .finally(() => {
          this.loading = false
        })
    }, 500),
    onRowInvoiceClick(invoice) {
      this.$emit('invoice', invoice)
    },
    onSelectTopOne() {
      console.log(this.invoices[0])
      // this.$emit('invoice', this.invoices[0])
    }
  }
}
</script>
